import { APPOINTMENT_TYPE } from '@hopdrive/sdk-appointments';

const TYPE_LABELS: Record<string, string> = {
  [APPOINTMENT_TYPE.MOBILE_SERVICE]: 'Mobile Service',
  [APPOINTMENT_TYPE.VALET]: 'Valet',
};

export const formatAppointmentType = (type?: string | null): string => {
  if (!type) return '—';
  if (TYPE_LABELS[type]) return TYPE_LABELS[type];
  return type
    .split('_')
    .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ');
};
